import React, { useState, useEffect } from 'react';
import Papa from "papaparse";
import '../assets/css/Detail.css';
import RelatedTour from '../components/RelatedTour';
import { useLocation } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
var Loader = require('react-loader');
// import "../assets/css/style.css";
const Detail = () => {

  const location = useLocation();
  const tourId = location.state != null ? location.state.id : 1;

  const [tour, setTour] = useState(null);
  const [loaded, setLoaded] = useState(false);
  const [expandedDay, setExpandedDay] = useState(1);
  const [idArray, setIdArray] = useState([1]);

  const toggleExpand = (day) => {
    setExpandedDay(expandedDay === day ? null : day);
    if (idArray.includes(day)) {
      setIdArray(idArray.filter(item => item !== day));
    } else {
      setIdArray([...idArray, day]);
    }
  };


  useEffect(() => {
    setLoaded(false);
    setIdArray([1]);
    const sheetURL =
      "https://docs.google.com/spreadsheets/d/e/2PACX-1vQJB4XDn4cM60lvPxxVwBp8--5AHiSti_X9DNNSbnH_L1SnzodWZRsBM2E8wFUKbdIzsdBQMga5x-Dr/pub?output=csv";

    Papa.parse(sheetURL, {
      download: true,
      header: true,
      complete: function (results) {
        const rows = results.data;

        // ✅ Group rows by tour id
        const groupedTours = {};
        rows.forEach((row) => {
          const id = Number(row.id);
          if (!groupedTours[id]) {
            groupedTours[id] = {
              id,
              tourDetails: {
                tourName: row["tourDetails.tourName"],
                displayName: row["tourDetails.displayName"],
                dates: {
                  startDate: row["tourDetails.startDate"],
                  endDate: row["tourDetails.endDate"],
                },
                TimeDuration: row["tourDetails.TimeDuration"],
                duration: row["tourDetails.TimeDuration"],
                dayDuration: row["tourDetails.dayDuration"],
                thumbnail: row["tourDetails.thumbnail"],
                thumbnail1: row["tourDetails.thumbnail1"],
                image: row["tourDetails.image"],

        price: {
  amount: row["tourDetails.price.amount"]
},


                shortDescription: row["tourDetails.shortDescription"],
                destination: row["tourDetails.destination"],
                transportType: row["tourDetails.transportType"],
                extracharge: row["tourDetails.extracharge"],
                freeCancellation: row["tourDetails.freeCancellation"] === "true",
                itineraryDescription: row["tourDetails.itineraryDescription"],
                itinerary: [],
              },
            };
          }

          // ✅ Build each day's itinerary
          const itineraryItem = {
            day: Number(row.day),
            Date: row.Date,
            Time: row.Time,
            plan: {
              Shortdescription: row.Shortdescription,
              Place: row.Place,
              description: [],
            },
          };

          // ✅ Collect all description columns dynamically
          Object.keys(row).forEach((key) => {
            if (key.toLowerCase().startsWith("description") && row[key]) {
              itineraryItem.plan.description.push(row[key]);
            }
          });

          groupedTours[id].tourDetails.itinerary.push(itineraryItem);
        });

        const parsedTours = Object.values(groupedTours);
        const selected = parsedTours.find((t) => t.id === tourId);

        if (selected) {
          setTimeout(() => {
            setTour(selected);
            setLoaded(true);
          }, 300);
        }
      },
    });
  }, [tourId]);



  if (!tour) {
    return <Loader loaded={loaded}></Loader>;
  }

  return (
    <div className='background'>

      <Loader loaded={loaded}>
        <Header />
        <div className="banner">
          <img className="img" src={tour.tourDetails.image} alt="Tour Banner" />
          <div className="caption date">
            <h1 className="TripName">{tour.tourDetails.tourName}</h1>
            <p>{tour.tourDetails.duration}</p>
          </div>
        </div>
        <div className="priceContainer">

          <div className="col-lg-12 col-md-12">
            <div className="row">
              <div className="col-lg-8 col-md-8">
                <p className='From'>Starts From</p>
                <p className='Price'>
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-currency-rupee" viewBox="0 0 16 16">
                    <path d="M4 3.06h2.726c1.22 0 2.12.575 2.325 1.724H4v1.051h5.051C8.855 7.001 8 7.558 6.788 7.558H4v1.317L8.437 14h2.11L6.095 8.884h.855c2.316-.018 3.465-1.476 3.688-3.049H12V4.784h-1.345c-.08-.778-.357-1.335-.793-1.732H12V2H4z" />
                  </svg>{tour.tourDetails.price.amount}<span className='Tag7'>{tour.tourDetails.extracharge}</span>
                </p>
                <p className='Per'>Per Person</p>
              </div>
              <div className="col-lg-4 col-md-4 connect">
                <a href="tel:+919443545454"><button type="button" class="btn btn-success">Connect Now</button></a>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-12 col-md-12 shortdesc">
                <p className='ShortDescription'>{tour.tourDetails.shortDescription}</p>
              </div>
            </div>
          </div>
        </div>

        <section className='Detail'>
          <div className='container'>
            <div className="row">
              {/* Destination */}
              <div className="col-lg-3 col-sm-12 col-md-12 desig">
                <div className='Img'>
                  <img src='images/geo-alt.svg' alt="Location" /><span className='Imgname'>Destination</span>
                  <p className="para">&nbsp;{tour.tourDetails.destination}</p>
                </div>
                <div className='VerticalLine Hide'>
                  <img src='images/Line.png' alt="Line" />
                </div>
              </div>
{/* Duration */}
              <div className="col-12 col-sm-6 col-md-3 calender">
                <div className='Img1'>
                  <img src='images/calendar-range.svg' alt="Calender" /><span className='Imgname'>Duration</span>
                  <p className="para">{tour.tourDetails.duration}</p>
                </div>

                <div className='VerticalLine Hide LineHide'>
                  <img src='images/Line.png' alt="Line" />
                </div>

              </div>
{/* Transport */}
              <div className="col-12 col-sm-6 col-md-3 transport down">
                <div className='Img1 Img3'>
                  <img src='images/Transport.svg' alt="Transport" /><span className='Imgname'>Transport Type</span>
                  <p className="para">{tour.tourDetails.transportType}</p>
                </div>

                <div className='VerticalLine thick Hide'>
                  <img src='images/Line.png' alt="Line" />
                </div>
              </div>
                {/* Cancellation */}
              <div className="col-12 col-sm-6 col-md-3 cancel down">
                <div className='Img1'>
                  <img src='images/clipboard2-check.svg' alt="Clipboard" /><span className='Imgname'>Free Cancellation</span>
                  <p className="para">Cancel up to 24 hours in advance</p>
                </div>
              </div>
            </div>
          </div>
{/* Itinerary Section */}
          <div className='Itinerary container'>
            <div>
              <div className='row'>
                <div className='col-12'>
                  <div className='Itinery'>
                    <h4 className='ItineryTitle'>Itinerary </h4><a href={`https://api.whatsapp.com/send/?phone=9585345454&text=${encodeURIComponent(tour.tourDetails.tourName)}&type=phone_number&app_absent=0`}><button className="itidownload">Download Itinerary</button><span className='itidownload1'>Download Itinerary</span></a>
                  </div>
                  <p className='ItineryDesc'>{tour.tourDetails.itineraryDescription}</p>
                </div>
              </div>
            </div>
{/* Day-wise Itinerary */}
            <div className='Daywisechart'>
              {tour.tourDetails.itinerary.map((dayInfo) => (
                <div key={dayInfo.day} class="Day" style={{ height: idArray.includes(dayInfo.day) ? 'fit-content' : '90px', }}>
                  <div className='DDay'>
                    <button className='ExpandButton' onClick={() => toggleExpand(dayInfo.day)}>
                      {expandedDay === dayInfo.day ? (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="26"
                          height="26"
                          fill="white"
                          className="bi bi-dash-square-fill"
                          viewBox="0 0 16 16"
                        >
                          {/* Square */}
                          <rect width="16" height="16" fill="currentColor" />

                          {/* Minus icon (transparent fill) */}
                          <path
                            fill="white"
                            stroke="white"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="1.2"
                            d="M4 7.5h8"
                          />
                        </svg>

                      ) : (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="26"
                          height="26"
                          fill="white"
                          className="bi bi-dash-square-fill"
                          viewBox="0 0 16 16"
                        >
                          {/* Square */}
                          <rect width="16" height="16" fill="currentColor" />

                          {/* Plus icon (transparent fill) */}
                          <path
                            fill="white"
                            stroke="white"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="1"
                            d="M4 8.3h8M8 4v8"
                          />
                        </svg>
                      )}
                    </button>
                    <div className='DayWise' style={{ background: idArray.includes(dayInfo.day) ? '#386B33' : "#386B33", }}>
                      <b>Day {dayInfo.day} - </b>
                      <span className='DayWiseShort'>{dayInfo.plan.Shortdescription}</span>
                    </div>
                  </div>
                  <div className="DaywiseItinery">
                 

                    {idArray.includes(dayInfo.day) && (
                      <div className='DateTimeDetails'>
                        <div className='Part1'>

                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <g clip-path="url(#clip0_319_7246)">
                              <path fill-rule="evenodd" clip-rule="evenodd" d="M23.7255 0.169235C23.8114 0.239638 23.8805 0.328233 23.928 0.428622C23.9755 0.52901 24.0001 0.638688 24 0.749735V21.7497C23.9999 21.9231 23.9398 22.091 23.8298 22.225C23.7199 22.359 23.567 22.4508 23.397 22.4847L15.897 23.9847C15.8 24.0041 15.7 24.0041 15.603 23.9847L8.25 22.5147L0.897 23.9847C0.788233 24.0065 0.675998 24.0038 0.568381 23.977C0.460764 23.9501 0.360444 23.8997 0.274649 23.8294C0.188854 23.7591 0.11972 23.6706 0.0722277 23.5704C0.0247353 23.4702 6.69791e-05 23.3607 0 23.2497L0 2.24973C0.000104673 2.07642 0.0602342 1.90848 0.170165 1.77449C0.280096 1.64049 0.433042 1.54871 0.603 1.51473L8.103 0.0147347C8.20004 -0.00466145 8.29996 -0.00466145 8.397 0.0147347L15.75 1.48473L23.103 0.0147347C23.2117 -0.00714161 23.324 -0.00463134 23.4316 0.0220847C23.5392 0.0488006 23.6396 0.0990573 23.7255 0.169235ZM15 2.86473L9 1.66473V21.1347L15 22.3347V2.86473ZM16.5 22.3347L22.5 21.1347V1.66473L16.5 2.86473V22.3347ZM7.5 21.1347V1.66473L1.5 2.86473V22.3347L7.5 21.1347Z" fill="#386B33" />
                            </g>
                            <defs>
                              <clipPath id="clip0_319_7246">
                                <rect width="24" height="24" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>

                          <span className='place'>{dayInfo.plan.Place}</span>
                      
                        </div>

                        {/* Line */}
                        <img className='Line' src='images/LineGreen.png' alt='Vertical Line' />


                        <div className='Part2'>
                          <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                            <g clip-path="url(#clip0_319_7248)">
                              <path d="M10.4731 18.993V10.3253H9.4445C8.7078 10.718 7.9958 11.1554 7.3125 11.635V12.7644C7.92188 12.3468 8.88712 11.7569 9.35675 11.5018H9.37625V18.993H10.4731ZM12.4036 16.8724C12.48 17.9124 13.3689 19.1571 15.171 19.1571C17.2153 19.1571 18.421 17.4249 18.421 14.4918C18.421 11.349 17.1519 10.1562 15.2474 10.1562C13.7426 10.1562 12.3273 11.2483 12.3273 13.0959C12.3273 14.9809 13.6663 15.9721 15.0508 15.9721C16.263 15.9721 17.0495 15.3611 17.2981 14.6884H17.342C17.3355 16.8269 16.5929 18.2049 15.2214 18.2049C14.1424 18.2049 13.5834 17.4736 13.5151 16.8724H12.4036ZM17.2023 13.1072C17.2023 14.2382 16.2939 15.0248 15.2783 15.0248C14.3016 15.0248 13.4193 14.4024 13.4193 13.0747C13.4193 11.7374 14.365 11.1085 15.3172 11.1085C16.3459 11.1085 17.2023 11.7552 17.2023 13.1072Z" fill="#386B33" />
                              <path d="M5.6875 0C5.90299 0 6.10965 0.0856024 6.26202 0.237976C6.4144 0.390349 6.5 0.597012 6.5 0.8125V1.625H19.5V0.8125C19.5 0.597012 19.5856 0.390349 19.738 0.237976C19.8903 0.0856024 20.097 0 20.3125 0C20.528 0 20.7347 0.0856024 20.887 0.237976C21.0394 0.390349 21.125 0.597012 21.125 0.8125V1.625H22.75C23.612 1.625 24.4386 1.96741 25.0481 2.5769C25.6576 3.1864 26 4.01305 26 4.875V22.75C26 23.612 25.6576 24.4386 25.0481 25.0481C24.4386 25.6576 23.612 26 22.75 26H3.25C2.38805 26 1.5614 25.6576 0.951903 25.0481C0.34241 24.4386 0 23.612 0 22.75V4.875C0 4.01305 0.34241 3.1864 0.951903 2.5769C1.5614 1.96741 2.38805 1.625 3.25 1.625H4.875V0.8125C4.875 0.597012 4.9606 0.390349 5.11298 0.237976C5.26535 0.0856024 5.47201 0 5.6875 0ZM1.625 6.5V22.75C1.625 23.181 1.7962 23.5943 2.10095 23.899C2.4057 24.2038 2.81902 24.375 3.25 24.375H22.75C23.181 24.375 23.5943 24.2038 23.899 23.899C24.2038 23.5943 24.375 23.181 24.375 22.75V6.5H1.625Z" fill="#386B33" />
                            </g>
                            <defs>
                              <clipPath id="clip0_319_7248">
                                <rect width="26" height="26" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                          <p className='Date'>{dayInfo.Date}</p>

                          <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                            <path d="M13.812 8.93749C13.812 8.722 13.7264 8.51534 13.5741 8.36297C13.4217 8.2106 13.215 8.125 12.9996 8.125C12.7841 8.125 12.5774 8.2106 12.425 8.36297C12.2727 8.51534 12.1871 8.722 12.1871 8.93749V14.4007L9.86496 18.2681C9.75399 18.453 9.721 18.6744 9.77327 18.8836C9.82553 19.0928 9.95876 19.2727 10.1436 19.3837C10.3285 19.4947 10.5499 19.5276 10.7591 19.4754C10.9683 19.4231 11.1482 19.2899 11.2592 19.105L13.6967 15.0425C13.7722 14.9163 13.8121 14.772 13.812 14.6249V8.93749Z" fill="#386B33" />
                            <path d="M10.5624 0C10.3469 0 10.1402 0.0856015 9.98786 0.237973C9.83549 0.390345 9.74989 0.597005 9.74989 0.812491C9.74989 1.02798 9.83549 1.23464 9.98786 1.38701C10.1402 1.53938 10.3469 1.62498 10.5624 1.62498H11.3749V3.36371C9.16209 3.6834 7.09256 4.648 5.4248 6.13702C3.75704 7.62604 2.565 9.57346 1.99758 11.736C1.43015 13.8986 1.51251 16.1804 2.23436 18.2964C2.95621 20.4124 4.28554 22.2688 6.05631 23.6337L5.07807 24.612C4.9255 24.7643 4.83971 24.971 4.83956 25.1866C4.8394 25.4022 4.92491 25.6091 5.07725 25.7616C5.2296 25.9142 5.43632 26 5.65192 26.0002C5.86753 26.0003 6.07437 25.9148 6.22693 25.7625L7.43917 24.5502C9.1373 25.5034 11.0525 26.0026 12.9999 25.9997C14.9472 26.0026 16.8624 25.5034 18.5605 24.5502L19.7728 25.7625C19.9253 25.9148 20.1322 26.0003 20.3478 26.0002C20.5634 26 20.7701 25.9142 20.9224 25.7616C21.0748 25.6091 21.1603 25.4022 21.1601 25.1866C21.16 24.971 21.0742 24.7643 20.9216 24.612L19.945 23.6337C21.7158 22.2687 23.0451 20.4122 23.7669 18.296C24.4887 16.1799 24.5709 13.898 24.0033 11.7354C23.4357 9.57279 22.2434 7.62539 20.5754 6.13647C18.9075 4.64756 16.8377 3.68314 14.6248 3.36371V1.62498H15.4373C15.6528 1.62498 15.8595 1.53938 16.0118 1.38701C16.1642 1.23464 16.2498 1.02798 16.2498 0.812491C16.2498 0.597005 16.1642 0.390345 16.0118 0.237973C15.8595 0.0856015 15.6528 0 15.4373 0L10.5624 0ZM12.2491 4.90419C12.7489 4.86619 13.2508 4.86619 13.7506 4.90419C16.2639 5.0983 18.6044 6.25828 20.2809 8.14075C21.9574 10.0232 22.8396 12.4819 22.7425 15.0008C22.6454 17.5197 21.5764 19.9031 19.7599 21.6509C17.9435 23.3987 15.5206 24.375 12.9999 24.375C10.4791 24.375 8.05624 23.3987 6.23976 21.6509C4.42327 19.9031 3.35433 17.5197 3.2572 15.0008C3.16008 12.4819 4.04233 10.0232 5.71884 8.14075C7.39535 6.25828 9.7358 5.0983 12.2491 4.90419ZM4.11587e-09 5.68744C4.11587e-09 6.91105 0.541119 8.00953 1.39748 8.75378C2.65156 6.28372 4.65874 4.27654 7.12879 3.02247C6.58585 2.39771 5.86503 1.95371 5.0628 1.74989C4.26058 1.54607 3.41524 1.59216 2.63993 1.882C1.86462 2.17183 1.19635 2.69158 0.724553 3.37166C0.25276 4.05175 -3.72451e-05 4.85972 4.11587e-09 5.68744ZM21.9373 1.62498C20.7136 1.62498 19.6152 2.1661 18.8709 3.02247C21.341 4.27654 23.3481 6.28372 24.6022 8.75378C25.227 8.21083 25.671 7.49001 25.8748 6.68778C26.0786 5.88556 26.0325 5.04022 25.7427 4.26491C25.4529 3.4896 24.9331 2.82133 24.253 2.34953C23.5729 1.87774 22.765 1.62494 21.9373 1.62498Z" fill="#386B33" />
                          </svg>
                          <p className='Time'>{dayInfo.Time}</p>
                        </div>
                      </div>

                    )}

                    {idArray.includes(dayInfo.day) && (
                  <ul>
                        {dayInfo.plan.description.map((desc, index) => (
                          <li key={index} className="DescriptionItem">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                              fill="#386B33" className="bi bi-caret-right-fill"
                              viewBox="0 0 16 16">
                              <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                            </svg>
                            {desc}
                          </li>
                        ))}
                      </ul>

                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>

        </section>

        <RelatedTour />
        <Footer />
      </Loader>
    </div>
  );
};

export default Detail;
